<template>
	<div class="content-blocks">
		<section class="magazine-archive">
			<header class="magazine-archive__header">
				<!-- form-->
				<form
					class="magazine-form"
					v-if="props.years.length && ready"
				>
					<div class="magazine-form__input">
						<label
							class="sr-only"
							for="select-magazine-year"
						>Valitse vuosi:
						</label>
						<select
							id="select-magazine-year"
							class="magazine-form__select"
							v-model="terms.year"
						>
							<option
								v-for="year of props.years"
								:key="year.id"
								:name="year.name"
								:value="year.title"
							>
								{{ year.title }}
							</option>
						</select>
					</div>
				</form>
			</header>
			<!-- filtered results -->
			<div
				id="magazines"
				ref="filterResultsContainer"
				class="magazine-archive__wrapper"
				:aria-label="`Lehdet vuodelta ${terms.year}`"
				v-if="filteredMagazines && filteredMagazines.length > 0"
			>
				<article
					v-for="magazine of filteredMagazines"
					class="magazine-archive__item"
					:key="magazine.id"
				>
					<a
						:href="magazine.url"
						class="magazine-archive__content"
					>
						<figure v-if="magazine.image">
							<img
								:src="magazine.image.url"
								:height="magazine.image.height"
								:width="magazine.image.width"
								alt=""
							>
						</figure>
						<h3 class="magazine-archive__title">
							{{ magazine.title }}
						</h3>
					</a>
				</article>
			</div>
			<!-- No results-->
			<p v-else>
				Valitettavasti suodattamillasi ehdoilla ei löytynyt yhtään lehteä.
			</p>
		</section>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import queryString from 'query-string'

const props = defineProps({
	years: {
		type: [Array],
		required: false,
		default() {
			return []
		},
	},
	magazines: {
		type: [Array],
		required: false,
		default() {
			return []
		},
	},
})

const ready = ref(false)
// search terms
const terms = ref({})

// filtered magazines
const filteredMagazines = computed(() => {
	if(ready.value === false) return []

	const results = props.magazines.filter(item => {
		// filter by year
		if(terms.value.year && terms.value.year !== '') {
			if(String(item.issue_year) !== String(terms.value.year)) {
				return false
			}
		}

		return true
	})

	// Sort by issue_number in ascending order
	return results.sort((a, b) => {
		const aNumber = parseInt(a.issue_number) || 0
		const bNumber = parseInt(b.issue_number) || 0
		return aNumber - bNumber
	})
})

// filtered results container
const filterResultsContainer = ref(null)

// update query string to contain year
const updateQueryString = () => {
	const qs = queryString.stringify({
		...terms.value,
	}, {
		skipNull: true,
		skipEmptyString: true,
		arrayFormat: 'bracket',
	})

	window.history.replaceState(
		{},
		'',
		qs.length ? `${window.location.pathname}?${qs}` : window.location.pathname
	)
}

onMounted(() => {
	// parse query string
	const qs = queryString.parse(location.search, {
		arrayFormat: 'bracket',
	})

	// Iterate years from props
	if(qs.year) {
		terms.value.year = qs.year
	} else {
		terms.value.year = props.years.length > 0 ? props.years[0].title : ''
	}

	ready.value = true

	watch(() => terms.value, () =>{
		updateQueryString()
	}, {
		deep: true,
	})
})

</script>
